<template>
    <el-date-picker value-format="yyyy-MM-dd" :disabled="disabled" @change="changeVal" :clearable="clearable" :unlink-panels="unlinkPanels" type="daterange" :readonly="readonly" v-model="dateArr" ></el-date-picker>
</template>

<script>
    import commonFun from "@/utils/commonFun";

    export default {
        name: "dateRanger",
        props: {
            date: {
                type: Object,
                default: null
            },
            dateStart: {
                type: Object,
                default: null
            },
            dateEnd: {
                type: Object,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            rangeSeparator: {
                type: String,
                default: '-',
            },
            valueFormat: {
                type: String,
                default: 'yyyy-MM-dd',
            },
            unlinkPanels: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                dateArr: [this.dateStart, this.dateEnd]
            }
        },
        methods: {
            changeVal(val) {
                this.$emit("update:date", val);
                if (commonFun.isNotEmpty(val)) {
                    this.$emit("update:dateStart", val[0]);
                    this.$emit("update:dateEnd", val[1]);
                } else {
                    this.$emit("update:dateStart", null);
                    this.$emit("update:dateEnd", null);
                }
            }
        },
        watch: {
            dateStart(newValue, oldValue) {
                this.$set(this.dateArr, 0, commonFun.isEmpty(newValue)?'':newValue);
            },
            dateEnd(newValue, oldValue) {
                this.$set(this.dateArr, 1, newValue);
            },
            date(newValue, oldValue) {
                if (commonFun.isEmpty(newValue)||newValue.length<2) {
                    this.dateArr = ["",""];
                    this.$emit("update:dateStart", "");
                    this.$emit("update:dateEnd", "");
                }
            }
        },
    }
</script>

<style scoped>

</style>
